import React, { useRef, useEffect, useState, useContext } from "react";
import SplitPaneContext from "./Contexts/SplitPaneContext";
import Styles from "./App.module.css";
// import { Provider, connect } from "react-redux";
// import store from "./store/Store";

// export const Divider = (props) => {
//   const { onMouseDown, dragging } = useContext(SplitPaneContext);

//   return (
//     <div
//       {...props}
//       onMouseDown={onMouseDown}
//       // ontouchStart={onTouchStart}
//       className={dragging ? Styles.draggingresizer : Styles.resizer}
//     >
//       <span>. . .</span>
//     </div>
//   );
// };

// export const VerDivider = (props) => {
//   const { onMouseDown, dragging } = useContext(SplitPaneContext);

//   return (
//     <div
//       {...props}
//       onMouseDown={onMouseDown}
//       // ontouchStart={onTouchStart}
//       className={dragging ? Styles.verdraggingresizer : Styles.verresizer}
//     >
//       <span>...</span>
//     </div>
//   );
// };

// export const SplitPaneLeft = (props) => {
//   const topRef = useRef();
//   const { clientWidth, setClientWidth } = useContext(SplitPaneContext);

//   useEffect(() => {
//     if (!clientWidth) {
//       setClientWidth(topRef.current.clientWidth);
//       return;
//     }
//     topRef.current.style.minWidth = clientWidth + "px";
//     topRef.current.style.maxWidth = clientWidth + "px";
//   }, [clientWidth, setClientWidth, topRef]);

//   return <div {...props} className={Styles.split_pane_left} ref={topRef}></div>;
// };

// export const SplitPaneTop = (props) => {
//   const topRef = useRef();
//   const { clientHeight, setClientHeight } = useContext(SplitPaneContext);

//   useEffect(() => {
//     if (!clientHeight) {
//       setClientHeight(topRef.current.clientHeight);
//       return;
//     }

//     topRef.current.style.minHeight = clientHeight + "px";
//     topRef.current.style.maxHeight = clientHeight + "px";
//   }, [clientHeight, setClientHeight, topRef]);

//   return <div {...props} className={Styles.split_plane_top} ref={topRef}></div>
// }



// const SplitPane = ({ children, ...props }) => {
//   const [clientWidth, setClientWidth] = useState();
//   const [clientHeight, setClientHeight] = useState();
//   const [dragging, setDragging] = useState(false);
//   const XDividerPos = useRef(null);
//   const YDividerPos = useRef(null)
//   const parentWidth = useRef(null);

//   useEffect(() => {
//     let splithalf = parentWidth.current.getBoundingClientRect().width / 2;
//     props.pdffull === "true" ? setClientWidth(0.1) : setClientWidth(splithalf);
//   }, [props.pdffull]);

//   useEffect(() => {
//     let verticalhalf = parentWidth.current.getBoundingClientRect().height / 2;
//     setClientHeight(verticalhalf);
//   }, [])

//   useEffect(() => {
//     let splithalf = parentWidth.current.getBoundingClientRect().width / 2;
//     if (props.leftcontroller === "true") {
//       let parent = props.parentwidth - 230;
//       // console.log(parent);
//       if (props.pdfviewer === "true") {
//         setClientWidth(parent / 2);
//       }
//       if (props.pdfviewer === "false") {
//         setClientWidth(parent);
//       }
//     } else {
//       props.pdfviewer === "true"
//         ? setClientWidth(splithalf)
//         : setClientWidth(splithalf * 2);
//     }
//   }, [props.pdfviewer, props.leftcontroller, props.parentwidth, props.parentheight]);

//   const onMouseDown = (e) => {
//     setDragging(true);
//     XDividerPos.current = e.clientX;
//     YDividerPos.current = e.clientY;
//   };

//   // const onTouchStart = (e) => {
//   //   e.preventDefault();

//   //   setDragging(true);
//   //   XDividerPos.current = e.clientX;
//   // };

//   const onMouseUp = (e) => {
//     setDragging(false);
//     XDividerPos.current = null;
//     YDividerPos.current = null;
//   };

//   const onMouseMove = (e) => {
//     if (!XDividerPos.current || !YDividerPos.current) {
//       return;
//     }

//     if (XDividerPos.current) {
//       const newclientwidth = clientWidth + e.clientX - XDividerPos.current;
//       setClientWidth(newclientwidth);
//       XDividerPos.current = e.clientX;
//     }

//     if (YDividerPos.current) {
//       const newclientheight = clientHeight + e.clientY - YDividerPos.current;
//       setClientHeight(newclientheight);
//       YDividerPos.current = e.clientY;
//     }
//   };

//   useEffect(() => {
//     document.addEventListener("mouseup", onMouseUp);
//     document.addEventListener("mousemove", onMouseMove);
//     // document.addEventListener("touchend", onMouseUp);
//     // document.addEventListener("touchmove", onMouseMove);

//     return () => {
//       document.removeEventListener("mouseup", onMouseUp);
//       document.removeEventListener("mousemove", onMouseMove);
//       // document.addEventListener("touchend", onMouseUp);
//       // document.addEventListener("touchmove", onMouseMove);
//     };
//   });

//   return (
//     <div {...props} ref={parentWidth}>
//       <SplitPaneContext.Provider
//         value={{
//           clientWidth,
//           setClientWidth,
//           clientHeight,
//           setClientHeight,
//           onMouseDown,
//           dragging,
//           // splithalf,
//         }}
//       >
//         {children}
//       </SplitPaneContext.Provider>
//     </div>
//   );
// };

//splitpane for three window pane

export const Divider = (props) => {
  const { onMouseDown, dragging } = useContext(SplitPaneContext);

  return (
    <div
      {...props}
      onMouseDown={(e) => onMouseDown(e, "horizontal")}
      // ontouchStart={onTouchStart}
      className={dragging ? Styles.draggingresizer : Styles.resizer}
    >
      <span>. . .</span>
    </div>
  );
};

export const DividerLeft = (props) => {
  const { onMouseDown, dragging, activeDivider } = useContext(SplitPaneContext);

  return (
    <div
      {...props}
      onMouseDown={(e) => onMouseDown(e, "left")}
      // ontouchStart={onTouchStart}
      className={dragging && activeDivider === "left" ? Styles.verdraggingresizer : Styles.verresizer}
    >
      <span>...</span>
    </div>
  );
};

export const VerDivider = (props) => {
  const { onMouseDown, dragging, activeDivider } = useContext(SplitPaneContext);

  return (
    <div
      {...props}
      onMouseDown={(e) => onMouseDown(e, "middle")}
      // ontouchStart={onTouchStart}
      className={dragging && activeDivider === "middle" ? Styles.verdraggingresizer : Styles.verresizer}
    >
      <span>...</span>
    </div>
  );
};

export const SplitPaneMiddle = (props) => {
  const topRef = useRef();
  const { clientWidth, setClientWidth } = useContext(SplitPaneContext);

  useEffect(() => {
    if (!clientWidth) {
      setClientWidth(topRef.current.clientWidth);
      return;
    }
    topRef.current.style.minWidth = clientWidth + "px";
    topRef.current.style.maxWidth = clientWidth + "px";
  }, [clientWidth, setClientWidth, topRef]);

  return <div {...props} className={Styles.split_pane_left} ref={topRef}></div>;
};

export const SplitPaneLeft = (props) => {
  const topRef = useRef();
  const { leftPanelWidth, setLeftPanelWidth } = useContext(SplitPaneContext);

  useEffect(() => {
    if (!leftPanelWidth) {
      setLeftPanelWidth(topRef.current.leftPanelWidth);
      return;
    }
    props.leftcontroller === "true" ? topRef.current.style.minWidth = 230 + "px" : topRef.current.style.minWidth = leftPanelWidth + "px";
    topRef.current.style.maxWidth = leftPanelWidth + "px";
  }, [leftPanelWidth, setLeftPanelWidth, topRef, props.leftcontroller]);

  return <div {...props} className={Styles.split_pane_left} ref={topRef}></div>;
};

export const SplitPaneTop = (props) => {
  const topRef = useRef();
  const { clientHeight, setClientHeight } = useContext(SplitPaneContext);

  useEffect(() => {
    if (!clientHeight) {
      setClientHeight(topRef.current.clientHeight);
      return;
    }

    topRef.current.style.minHeight = clientHeight + "px";
    topRef.current.style.maxHeight = clientHeight + "px";
  }, [clientHeight, setClientHeight, topRef]);

  return <div {...props} className={Styles.split_plane_top} ref={topRef}></div>
}

const SplitPane = ({ children, ...props }) => {
  const [leftPanelWidth, setLeftPanelWidth] = useState();
  const [clientWidth, setClientWidth] = useState();
  const [clientHeight, setClientHeight] = useState();
  const [dragging, setDragging] = useState(false);
  const [activeDivider, setActiveDivider] = useState();
  const X0DividerPos = useRef(null);
  const XDividerPos = useRef(null);
  const YDividerPos = useRef(null)
  const parentWidth = useRef(null);

  useEffect(() => {
    let splithalf;
    if (props.leftcontroller === "true") {
      splithalf = (parentWidth.current.getBoundingClientRect().width - 240) / 2;
    } else {
      splithalf = (parentWidth.current.getBoundingClientRect().width) / 2;
    }
    props.pdffull === "true" ? setClientWidth(1) : setClientWidth(splithalf);
  }, [props.pdffull, props.leftcontroller]);

  useEffect(() => {
    let verticalhalf = parentWidth.current.getBoundingClientRect().height / 2;
    setClientHeight(verticalhalf);
  }, [])

  useEffect(() => {
    let leftpanel;
    if (props.leftcontroller === "true") {
      leftpanel = 240;
    } else {
      leftpanel = 1;
    }
    setLeftPanelWidth(leftpanel)
  }, [props.leftcontroller])

  useEffect(() => {
    if (props.leftcontroller === "true") {
      let parent = props.parentwidth - leftPanelWidth;

      if (props.pdfviewer === "true") {
        setClientWidth(parent / 2);
      }
      if (props.pdfviewer === "false") {
        setClientWidth(parent);
      }
    } else {
      let parent = props.parentwidth;

      if (props.pdfviewer === "true") {
        setClientWidth(parent / 2)
      }
      if (props.pdfviewer === "false") {
        setClientWidth(parent)
      }
    }
  }, [props.pdfviewer, props.leftcontroller, props.parentwidth, props.parentheight]);

  const onMouseDown = (e, type) => {
    setDragging(true);
    setActiveDivider(type)
    X0DividerPos.current = e.clientX;
    XDividerPos.current = e.clientX;
    YDividerPos.current = e.clientY;
  };


  const onMouseUp = (e) => {
    setDragging(false);
    setActiveDivider(null)
    X0DividerPos.current = null;
    XDividerPos.current = null;
    YDividerPos.current = null;
  };

  const onMouseMove = (e) => {
    if (!dragging || !activeDivider) return;

    if (!XDividerPos.current || !YDividerPos.current) {
      return;
    }

    if (activeDivider === "middle") {
      const newclientwidth = clientWidth + e.clientX - XDividerPos.current;
      setClientWidth(newclientwidth);
      XDividerPos.current = e.clientX;
    }

    if (activeDivider === "horizontal") {
      const newclientheight = clientHeight + e.clientY - YDividerPos.current;
      setClientHeight(newclientheight);
      YDividerPos.current = e.clientY;
    }

    if (activeDivider === "left") {
      const newLeftpanelwidth = leftPanelWidth + e.clientX - X0DividerPos.current;
      setLeftPanelWidth(newLeftpanelwidth)
      X0DividerPos.current = e.clientX;
    }
  };

  useEffect(() => {
    document.addEventListener("mouseup", onMouseUp);
    document.addEventListener("mousemove", onMouseMove);
    // document.addEventListener("touchend", onMouseUp);
    // document.addEventListener("touchmove", onMouseMove);

    return () => {
      document.removeEventListener("mouseup", onMouseUp);
      document.removeEventListener("mousemove", onMouseMove);
      // document.addEventListener("touchend", onMouseUp);
      // document.addEventListener("touchmove", onMouseMove);
    };
  });

  return (
    <div {...props} ref={parentWidth}>
      <SplitPaneContext.Provider
        value={{
          leftPanelWidth,
          setLeftPanelWidth,
          clientWidth,
          setClientWidth,
          clientHeight,
          setClientHeight,
          onMouseDown,
          dragging,
          activeDivider
          // splithalf,
        }}
      >
        {children}
      </SplitPaneContext.Provider>
    </div>
  );
}

export default SplitPane;
